'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _vuex = require('vuex');

var _themeCart = require('@shopify/theme-cart');

var shopifyCart = _interopRequireWildcard(_themeCart);

var _CustomBoxItem = require('./CustomBoxItem');

var _CustomBoxItem2 = _interopRequireDefault(_CustomBoxItem);

var _functional = require('../../../utils/functional');

var _utils = require('../../../utils');

var _urlSearchParams = require('@ungap/url-search-params');

var _urlSearchParams2 = _interopRequireDefault(_urlSearchParams);

var _store = require('store2');

var _store2 = _interopRequireDefault(_store);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'CustomBox',

  props: {
    data: {
      type: Object,
      required: true
    }
  },

  data: function data() {
    return {
      boxItems: this.createBoxItems(this.data.box.amount),
      currentBoxMax: this.data.box.amount
    };
  },
  created: function created() {
    var _this = this;

    document.body.addEventListener('submit', function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(e) {
        var form, formData, id, quantity, properties;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                form = e.target;

                if (!form.matches('.js-AddToCartBox')) {
                  _context.next = 12;
                  break;
                }

                e.preventDefault();

                formData = new FormData(form);
                id = Number(formData.get('id'));
                quantity = Number(formData.get('quantity'));
                properties = (0, _functional.buildProperties)(formData);
                _context.next = 9;
                return shopifyCart.addItem(id, { properties: properties, quantity: quantity });

              case 9:
                _context.next = 11;
                return _store2.default.clearAll();

              case 11:
                window.location.href = '/cart';

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());

    document.body.addEventListener('click', function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(e) {
        var button, hasMatchingButton, productHandle, firstEmptyIndex, product;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                button = e.target;
                hasMatchingButton = button.matches('.js-BuildABox_Add');

                if (!(hasMatchingButton === false)) {
                  _context2.next = 4;
                  break;
                }

                return _context2.abrupt('return');

              case 4:

                e.preventDefault();

                if (window.drawers.activeDrawerKey !== '') {
                  window.drawers.activeDrawerKey = '';
                }

                productHandle = button.dataset.productHandle;
                firstEmptyIndex = _this.boxItems.findIndex(function (item) {
                  return (0, _keys2.default)(item.product).length === 0;
                });


                _this.$set(_this.boxItems, firstEmptyIndex, (0, _assign2.default)({}, _this.boxItems[firstEmptyIndex], { loading: true }));

                _context2.next = 11;
                return (0, _functional.getProductData)(productHandle);

              case 11:
                product = _context2.sent;


                _this.$set(_this.boxItems, firstEmptyIndex, (0, _assign2.default)({}, _this.boxItems[firstEmptyIndex], { product: product, theme: product.metafields.accentuate.product_theme_colour, loading: false }));

                if (_this.isFilled) {
                  window.drawers.activeDrawerKey = 'custombox';
                }

              case 14:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this);
      }));

      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }());

    var searchParams = new _urlSearchParams2.default(window.location.search);
    if (searchParams.get('scrollto') === 'cocktails') {
      scrollToCocktails();
    }

    function scrollToCocktails() {
      var scrollTo = (0, _functional.getElement)('.js-BuildABox_Scroll');

      if (scrollTo) {
        (0, _utils.scrollToY)((0, _utils.getOffsetTop)(scrollTo));
      }
    }

    if (_store2.default.has('baoCustomBox' + this.data.collectionHandle)) {
      var sessionData = _store2.default.get('baoCustomBox' + this.data.collectionHandle);

      var currentDate = Date.parse(Date());
      var endDate = Date.parse(sessionData.endDate);

      if (currentDate - endDate > 0) {
        _store2.default.clearAll();
      } else {
        this.boxItems = sessionData.boxItems;
      }
    }
  },


  components: {
    CustomBoxItem: _CustomBoxItem2.default
  },

  computed: {
    orderedBoxItems: function orderedBoxItems() {
      return this.boxItems.sort(function (a, b) {
        var titleA = a.product.title;
        var titleB = b.product.title;
        if (titleA < titleB) {
          return -1;
        }
        if (titleA > titleB) {
          return 1;
        }
        return 0;
      });
    },
    titleString: function titleString() {
      if (this.isFilled) {
        return this.data.translations.fullTitle;
      } else {
        return this.data.translations.title.replace('{{ box_amount }}', this.currentBoxMax);
      }
    },
    counterString: function counterString() {
      var _this2 = this;

      var cardButtons = (0, _functional.getElements)('.js-BuildABox_Add');

      cardButtons.forEach(function (cardButton) {
        var cardButtonText = (0, _functional.getElement)('.btn-Text', { context: cardButton });
        var cardButtonInventory = parseInt(cardButton.dataset.inventoryQuantity);
        var isAdded = false;

        (0, _keys2.default)(_this2.boxItems).forEach(function (item) {
          if (_this2.boxItems[item].product.handle) {
            if (_this2.boxItems[item].product.handle === cardButton.dataset.productHandle) {
              isAdded = true;
            }
          }
        });

        var addNewText = cardButtonInventory > 0 ? _this2.data.translations.buttonAddText : _this2.data.translations.buttonPreOrderText;
        var addAnotherText = cardButtonInventory > 0 ? _this2.data.translations.buttonAddedText : _this2.data.translations.buttonAddedPreOrderText;
        var buttonFullText = _this2.data.translations.buttonFullText;

        var defaultText = cardButtonText.getAttribute("data-text");

        if (defaultText === null) {
          defaultText = addNewText;
        }

        //cardButtonText.innerHTML = isAdded ? addAnotherText : addNewText
        cardButtonText.innerHTML = _this2.isFilled ? buttonFullText : isAdded ? addAnotherText : defaultText;
      });

      return this.data.translations.countMessage.replace('{{ current_amount }}', this.filledBoxItems.length).replace('{{ box_amount }}', this.currentBoxMax);
    },
    filledBoxItems: function filledBoxItems() {
      return this.boxItems.filter(function (boxItem) {
        return (0, _keys2.default)(boxItem.product).length > 0;
      });
    },
    isFilled: function isFilled() {
      return this.filledBoxItems.length == this.currentBoxMax;
    },
    isEmpty: function isEmpty() {
      return this.filledBoxItems.length == 0;
    },
    buttonString: function buttonString() {
      return (0, _functional.formatMoney)(this.data.box.product.price) + ' - ' + this.data.translations.buttonText;
    }
  },

  watch: {
    currentBoxMax: function currentBoxMax(val) {
      if (val > this.boxItems.length) {
        this.boxItems = [].concat((0, _toConsumableArray3.default)(this.boxItems.slice(0, val)), (0, _toConsumableArray3.default)(this.createBoxItems(val - this.boxItems.length)));
      } else if (val < this.boxItems.length) {
        this.boxItems = [].concat((0, _toConsumableArray3.default)(this.boxItems.slice(0, val)));
      }
    },
    isFilled: function isFilled(val) {
      if (val) {
        window.drawers.activeDrawerKey = 'custombox';
      }
    }
  },

  updated: function updated() {
    var endDate = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);

    _store2.default.set('baoCustomBox' + this.data.collectionHandle, { boxItems: this.boxItems, currentBoxMax: this.currentBoxMax, endDate: endDate });

    var customBoxDrawer = (0, _functional.getElement)('.js-CustomBox_Drawer');
    var animateClass = 'drw-PushBox-animate';

    if (!customBoxDrawer.matches('.drw-Drawer-active')) {
      customBoxDrawer.classList.add(animateClass);

      setTimeout(function () {
        customBoxDrawer.classList.remove(animateClass);
      }, 500);
    }
  },


  methods: {
    formatMoney: _functional.formatMoney,

    createBoxItems: function createBoxItems(amount) {
      return (0, _functional.range)(amount).map(function (_, i) {
        return { product: {}, theme: null, loading: false };
      });
    },
    boxTitleString: function boxTitleString(val) {
      return this.data.translations.title.replace('{{ box_amount }}', val);
    },
    removeItem: function removeItem(index, hasContent) {
      if (hasContent) {
        this.boxItems.splice(index, 1);
        this.boxItems = [].concat((0, _toConsumableArray3.default)(this.boxItems.slice(0, this.boxItems.length)), (0, _toConsumableArray3.default)(this.createBoxItems(1)));
      }
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//